import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { createFrontendModule, TranslationBlueprint } from '@backstage/frontend-plugin-api';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

const userSettingsMessages = createTranslationMessages({
  ref: userSettingsTranslationRef,
  full: false,
  messages: {
    'languageToggle.title': "Idioma",
    'languageToggle.description': "Mudar o idioma",
    'languageToggle.select': "Selecionar o idioma {{language}}",
    'themeToggle.title': "Tema",
    'themeToggle.description': "Mudar o modo do tema",
    'themeToggle.select': "Selecionar {{theme}}",
    'themeToggle.selectAuto': "Selecionar Tema Auto",
    'themeToggle.names.light': "Light",
    'themeToggle.names.dark': "Dark",
    'themeToggle.names.auto': "Auto",
    'signOutMenu.title': "Sair",
    'signOutMenu.moreIconTitle': "mais",
    'pinToggle.title': "Fixar Barra Lateral",
    'pinToggle.description': "Impedir recolhimento da barra lateral",
    'pinToggle.switchTitles.unpin': "Desafixar Barra Lateral",
    'pinToggle.switchTitles.pin': "Fixar Barra Lateral",
    'pinToggle.ariaLabelTitle': "Fixar interruptor da Barra Lateral",
    'identityCard.title': "Identidade do Backstage",
    'identityCard.noIdentityTitle': "Sem Identidade do Backstage",
    'identityCard.userEntity': "Entidade do Usuário",
    'identityCard.ownershipEntities': "Entidades Proprietárias",
    'defaultProviderSettings.description': "Fornece autenticação através das APIs e identidades de {{provider}}",
    'emptyProviders.title': "Sem Provedores de Autenticação",
    'emptyProviders.description': "Você pode adicionar Provedores de Autenticação ao Backstage para poder utilizar estes provedores para se autenticar.",
    'emptyProviders.action.title': "Abra app-config.yaml e modifique conforme exemplo destacado abaixo:",
    'emptyProviders.action.readMoreButtonTitle': "Ler Mais",
    'providerSettingsItem.title.signIn': "Entrar em {{title}}",
    'providerSettingsItem.title.signOut': "Sair de {{title}}",
    'providerSettingsItem.buttonTitle.signIn': "Entrar",
    'providerSettingsItem.buttonTitle.signOut': "Sair",
    'authProviders.title': "Provedores Disponíveis",
    'defaultSettingsPage.tabsTitle.general': "Geral",
    'defaultSettingsPage.tabsTitle.authProviders': "Provedores de Autenticação",
    'defaultSettingsPage.tabsTitle.featureFlags': "Feature Flags",
    'featureFlags.title': "Feature Flags",
    'featureFlags.description': "Por favor atualize a página ao modificar feature flags",
    'featureFlags.emptyFlags.title': "Sem Feature Flags",
    'featureFlags.emptyFlags.description': "Feature Flags possibilitam que plugins registrem funcionalidades no Backstage que usuários podem optar. Você pode usar isto para separar a lógica do seu código para testes manuais A/B, etc.",
    'featureFlags.emptyFlags.action.title': "Um exemplo de como adicionar uma feature flag abaixo:",
    'featureFlags.emptyFlags.action.readMoreButtonTitle': "Ler Mais",
    'featureFlags.filterTitle': "Filtrar",
    'featureFlags.clearFilter': "Limpar filtros",
    'featureFlags.flagItem.title.disable': "Desativar",
    'featureFlags.flagItem.title.enable': "Ativar",
    'featureFlags.flagItem.subtitle.registeredInApplication': "Registrado na aplicação",
    'featureFlags.flagItem.subtitle.registeredInPlugin': "Registrado no plugin {{pluginId}}",
    'settingsLayout.title': "Configurações",
    'sidebarTitle': "Configurações",
    'profileCard.title': "Perfil",
    'appearanceCard.title': "Aparência"
  },
});

export const userSettingsTranslationModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [
    TranslationBlueprint.make({
      name: 'user-settings-overrides',
      params: {
        resource: userSettingsMessages
      },
    }),
  ]
})